import React, { useState } from 'react';
import {
  TopToolbar,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import UploadMarkdownsDialog from './UploadMarkdownsDialog';

const ItemAdjustedPricesActions = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  return (
    <TopToolbar sx={{ flex: 'none' }}>
      <Button
        label="Upload"
        onClick={() => setIsUploadOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <UploadMarkdownsDialog
        open={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
    </TopToolbar>
  );
};

export default ItemAdjustedPricesActions;
